export const DataLimit = {
  PostsByFollowing: 6,
  PostsByChannelName: 6,
  PostsByAuthorId: 6,
  Members: 10,
  Notifications: 10,
  Membership: 5,
  AdminUsers: 40,
  Documents: 5,
};
